module.exports = __webpack_public_path__ + "img/top.464b3018.png";